import React,{useCallback,useContext,useEffect, useState,useRef, useMemo} from 'react';
import { getRequest, postRequest, putRequest,deleteRequest } from '../../api/ApiController';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { ReactTabulator, reactFormatter } from 'react-tabulator';
import '../../assets/css/style.css';
import '../../assets/css/iconsmenu.css'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import { AddIcon, EditIcon, CopyIcon, DeleteIcon, StepBackIcon, PrintIcon, SearchIcon, ExportIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon,EditRowIcon} from "../svg/svgIcons";
import UtilContext from '../../components/UtilContext';
import { LocaleContext } from '../../components/LocaleContext';
import { scrollToFirst as scrollToFirstUtil, scrollUp as scrollUpUtil, scrollDown as scrollDownUtil, scrollToLast as scrollToLastUtil } from '../../utils/tabulatorScroll';
import { defaultProductLogoSrc } from '../../constants/brandingDisplay';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../utils/printChrome';
import { applyTabulatorRuntimeI18n } from '../../utils/tabulatorRuntimeI18n';

const CUSTOMER_LIST_COLUMN_I18N_KEYS = Object.freeze({
  name: 'CustomerList.Column.Name',
  description: 'CustomerList.Column.Description',
  defined_id: 'CustomerList.Column.DefinedId',
});

export default function CustomerList(){

    const [state,dispatch] = useContext(DatabaseContext);
    const {openFavoriteDialog,toast,setFastView,setVisible,setDialogText}= useContext(UtilContext);
    const { t, locale } = useContext(LocaleContext);

    const [stepBackIcon,setStepBackIcon] = useState(true);
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [favoriteIcon,setFavoriteIcon] = useState(false);
    const [copyIcon,setCopyIcon] = useState(true);

    const [visibleSearch,setVisibleSearch] = useState(false);
    const [visibleLoading,setVisibleLoading] = useState(false);
    const [searchValue,setSearchValue] = useState('');
    const [favoriteVisible,setFavoriteVisible] = useState(false);
    const [favoriteGroupValue,setFavoriteGroupValue] = useState("");
    const [favoriteValue,setFavoriteValue] = useState("");

    const [editFormCustomer, setEditFormCustomer] = useState([]);

    const ref = useRef(null);
    const elementRef = useRef(null);
    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);

  useEffect(() => {
    const table = typeof getTable === 'function' ? getTable() : null;
    if (!table?.getColumns) return;
    applyTabulatorRuntimeI18n(table, t, {
      columnTitleKeys: CUSTOMER_LIST_COLUMN_I18N_KEYS,
      placeholder: typeof t === 'function' ? t('Common.NoData') : undefined,
      reformatRows: true,
    });
  }, [locale, t, getTable]);

  function matchAny(data, filterParams) {
    //data - the data for the row being filtered
    //filterParams - params object passed to the filter
    //RegExp - modifier "i" - case insensitve

    var match = false;
    const regex = RegExp(filterParams.value, 'i');

    for (var key in data) {
        if (regex.test(data[key]) === true) {
            match = true;
        }
    }
    return match;
  }

  function searchTable(){
    ref.current.setFilter(matchAny, { value: searchValue});
    if (searchValue === " ") {
      ref.current.clearFilter()
    }
    setVisibleSearch(false);
  }

    const accept = () => {
        let rows_to_delete = [];
        rows_to_delete = ref.current.getSelectedData();
        rows_to_delete.forEach(element => {
          console.log(element);
          deleteRequest(`/api/customers/${element.id}`)
              .then((response) => {
                toast?.current?.show({ severity: 'info', summary: t('DepartmentList.Toast.DeletedSummary'), life: 3000, detail: t('DepartmentList.Toast.DeletedDetail') });
                getRequest("/api/customers").then((response) => {
                  dispatch({type:'load_customers',newCustomers:response.data});
                });
              }).catch((reason) => {
                  alert(reason);
                  toast?.current?.show({ severity: 'warn', summary: t('DepartmentList.Toast.RejectedSummary'), detail: t('DepartmentList.Toast.DeleteFailedDetail'), life: 3000 });
              })
        }); 
    }

    const reject = () => {
        toast?.current?.show({ severity: 'warn', summary: t('DepartmentList.Toast.RejectedSummary'), detail: t('ServiceTask.Toast.RequestCancelled'), life: 3000 });
    }

    const confirm = () => {
        confirmDialog({
            message: t('ServiceTask.ConfirmDeleteRecord'),
            header: t('ServiceTask.ConfirmDeleteTitle'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept: reject,
            reject: accept
        });
    };

  const rowClick = (e, row) => {
    console.log(e, row);
 };

  const onSelectRow = (data, rows) => {
    setEditFormCustomer(data);
      if(data.length === 0){
        setEditIcon(true);
        setCopyIcon(true);
        setDeleteIcon(true);
      }
      else{
        setEditIcon(false);
        setCopyIcon(false);
        setDeleteIcon(false);
      }
  };

  function onEditRow(customer){
    dispatch({type:'create_new_tab',name:t('CustomerList.Tab.Edit'), translationKey: 'CustomerList.Tab.Edit', legacyLabel: t('CustomerList.Tab.Edit'), page:'CustomerAdd',props:{customer: customer,type:'edit'},mask:'gset010'});
  };
  
  function EditRowFormatter(props) {
    const rowData = props.cell._cell.row.data;
    return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
  }

  const columns = useMemo(() => [
    { formatter:"rowSelection", titleFormatter:"rowSelection", hozAlign:"center",width: 20,headerSort:false},
    { hozAlign:"center",width: 20,headerSort:false,formatter: reactFormatter(<EditRowFormatter/>),resizable:false},
    { title: t('CustomerList.Column.Name'), field: 'name',editor: "input",headerFilter:"input"},
    { title: t('CustomerList.Column.Description'), field: 'description',headerFilter:"input" },
    { title: t('CustomerList.Column.DefinedId'), field: 'defined_id',headerFilter:"input" },
  ], [t]);

  const scrollToFirst = () => scrollToFirstUtil(ref.current);
  const scrollUp = () => scrollUpUtil(ref.current);
  const scrollDown = () => scrollDownUtil(ref.current);
  const scrollToLast = () => scrollToLastUtil(ref.current);
  function addNewCustomer(){
    dispatch({type:'create_new_tab',name:t('CustomerList.Tab.New'), translationKey: 'CustomerList.Tab.New', legacyLabel: t('CustomerList.Tab.New'), page:'CustomerAdd',props:{customer: null,type:'add'},mask:'gset010'})
  }
  function copyCustomer(){
    dispatch({type:'create_new_tab',name:t('CustomerList.Tab.New'), translationKey: 'CustomerList.Tab.New', legacyLabel: t('CustomerList.Tab.New'), page:'CustomerAdd',props:{customer: ref.current.getSelectedData()[0],type:'copy'},mask:'gset010'})
  }
  function editCustomer(){
    dispatch({type:'create_new_tab',name:t('CustomerList.Tab.Edit'), translationKey: 'CustomerList.Tab.Edit', legacyLabel: t('CustomerList.Tab.Edit'), page:'CustomerAdd',props:{customer: ref.current.getSelectedData()[0],type:'edit'},mask:'gset010'})
  }

  
    return(
        <>
      <div className='w-full h-10 flex flex-row bg-[#333]'>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => addNewCustomer()}><AddIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editCustomer()}><EditIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" disabled={copyIcon} onClick={() => copyCustomer()}><CopyIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={confirm} disabled={deleteIcon}><DeleteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => ref.current.print(false, true)}><PrintIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => setVisibleSearch(true)}><SearchIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => ref.current.download("xlsx", "data.xlsx", {sheetName:"MyData"})}><ExportIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => scrollToFirst()}><BackToFirstIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => scrollUp()}><BackIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => scrollDown()}><ForwardIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => scrollToLast()}><ForwardToLastIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" disabled={favoriteIcon} onClick={() => openFavoriteDialog(t('CustomerList.FavoriteTitle'),"CustomerList")}><FavoriteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => setFastView("CustomerList")}><PriceIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon/></div>
      </div>
      <div className="flex flex-col overflow-hidden min-h-[calc(100vh-177px)]">
  <div className="">
    <div className="inline-block w-full py-2">
    <div ref={elementRef}>
      <ReactTabulator
      data={state.customers} 
      className='h-[calc(100vh_-_193px)]' //176px
      onRef={(r) => (ref.current = r.current)}
      columns={columns}
      events={{
        rowClick: rowClick,
        rowSelectionChanged: onSelectRow
      }}
      options={{layout:"fitColumns",rowHeight:30,
      printAsHtml:true,
      printHeader: () => buildCanonicalPrintHeaderHtml({
        branding: state?.branding,
        productFallbackSrc: defaultProductLogoSrc,
        companySettingsPrint: state?.company_settings_print,
        moduleSettings: state?.module_settings,
        title: t('CustomerList.PrintTitle'),
        printDateLabel: t('Print.DateLabel'),
      }),
      printFooter: () => buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print }),
      printRowRange:"active",
      autoResize:true}}/> 
    </div> 
      </div>
    </div>
      <Dialog header={t('DepartmentList.SearchDialogTitle')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
        <div className="flex flex-columns">
          
          <input
              value={searchValue} onChange={e => setSearchValue(e.target.value)}
              type="text"
              className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
          />
          <button onClick={() => searchTable()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
        </div>
      </Dialog>
  </div>
        </>
    )

}